import BaseComponent from './BaseComponent';

class Filter extends BaseComponent {
  constructor(componentName){
    super(componentName);

  }

  init(component) {
    this.addCustomEvents(component);
  }

  addCustomEvents(component) {
    const links = component.element.getElementsByTagName('a');

    for(let link of links) {

      // EXPAND PARENT ACCORDIONS
      if(link.classList.contains('active')) {
        let tag = link.parentElement;
        while (!!tag && !tag.classList.contains('list--categories')) {
          if(tag.classList.contains('category-block')) {
            tag.classList.add('opened');
          }
          tag = tag.parentElement;
        }
        // break;
      }
    }
  }

  updateActiveOption() {}
}

export default Filter;
